import koLocale from 'element-ui/lib/locale/lang/ko'

export default {
  ...koLocale,
  "pageTitle": {
    "index": "韩国签证申请中心--官方授权指定机构",
    "login": "账号登录",
    "retrieve": "找回密码",
    "register": "注册账号",
    "center": "个人中心",
    "userMsg": "消息中心",
    "news": "新闻中心",
    "serviceCenter": "客户服务中心",
    "clientCenter": "客户中心",
    "tour": "旅游信息",
    "tourList": "旅游信息",
    "orderList": "我的订单",
    "orderDetail": "订单详情",
    "applyTodoList": "待办申请列表",
    "changePhone": "更换手机",
    "address": "常用地址",
    "addressDetail": "地址详情",
    "setting": "设置",
    "aboutUs": "关于我们",
    "contactUs": "联系我们",
    "businessCooperation": "商务合作",
    "FAQ": "常见问题",
    "feedback": "意见反馈",
    "changePsd": "修改密码",
    "choiceVisaType": "签证申请",
    "saveBasicInfo": "签证申请信息",
    "saveApplyInfo": "签证申请信息",
    "visaInformation": "签证申请信息",
    "confirmApply": "签证申请信息",
    "applicantInfo": "申请人信息",
    "sendMaterials": "申请寄送材料",
    "sendDataInfo": "签证申请",
    "receiveDataInfo": "签证申请",
    "visaData": "签证所需资料",
    "confirmPay": "确认支付",
    "msgList": "消息中心",
    "law": "韩国基本法秩序",
    "visaCenter": "签证中心",
    "siteMap": "网站地图",
    "paySuccess": "订单支付",
    "agreement": "用户协议",
    "invoiceList": "发票抬头",
    "invoiceDetail": "添加发票抬头",
    "generateFormSuccess": "生成申请表成功",
    changeEmail: "更换邮箱",
    applyInvoice: "申请发票",
    expressInfo: "物流信息",
    visaInQuery: "办理进度查询",
    TravelAgencyIdentity: "旅行社身份申请",
    queryResults: "查询结果",
  },
  header: {
    title: "대한민국온라인비자센터 방문을 환영합니다",
    login: {
      unLogin: {
        login: "로그인",
        register: "회원가입",
      },
      logined: {
        order: "주문서",
        todoList: "신청 중",
        message: "정보 센터",
        address: "현주소",
        changePsd: "비밀번호 변경",
        changePhone: "휴대폰 변경",
        changeEmail: "이메일 변경",
        logout: "로그아웃",
      },
    },
    todoList: "신청 중",
    lang: "한국어",
    nav: {
      index: "메인",
      visa: "비자신청",
      query: "신청조회",
      news: "뉴스",
      client: "고객 센터",
      tour: "여행 정보",
      aboutUs: "회사소개",
      law: "한국기초법질서",
      reservation: "线下预约",
    },
    menu: {
      guide: "비자안내",
      procedures: "비자신청절차",
      application: "비자신청",
      query: "발급조회",
      'offline booking': "오프라인 예약"
    },
    visas: "발행인 수",
    number: "명",
  },
  /*---------------------------   客户中心     --------------------------*/
  serviceCenter: {
    title: "고객센터",
    home: "메인",
    'Customer center': "고객센터",
    'Customer service center': "고객 서비스 센터"
  },
  /*---------------------------   旅游信息     --------------------------*/
  tour: {
    'Tourist information': "여행정보",
    'HOME': "메인",
    'hot spots': "강력추천",
    'Theme travel': "테마여행"
  },
  /*---------------------------   新闻中心     --------------------------*/
  news: {
    HOME: "메인",
    NEWS: "뉴스",
    LAW: "한국기초법질서",
  },
  /*---------------------------   登录页     --------------------------*/
  "login": {
    Copyright: "대한민국온라인비자신청센터",
    "title": {
      "s1": "계정이 없으시면？",
      "s2": "회원가입"
    },
    "welcome": "오신것을 환영합니다",
    loginType: {
      type1: "로그인",
      type2: "여행사 로그인"
    },
    "form": {
      "mobile": {
        "name": "手机号",
        "placeholder": "핸드폰 번호를 입력해 주세요"
      },
      "password": {
        "name": "密码",
        "placeholder": "비밀번호를 입력"
      },
      account: {
        "name": "账号",
        "placeholder": "여행사 계좌 번호를 입력해 주세요"
      },
      "authCode": {
        "name": "验证码",
        "placeholder": "그래픽 검증 코드를 입력해 주세요"
      }
    },
    "rulesErr": {
      'mobile is required': "핸드폰 번호를 입력해 주세요",
      "mobile is not correct": "핸드폰번호가 정확하지 않습니다",
      "account is required": "여행사 계좌 번호를 입력해 주세요",
      "password is required": "비밀번호를 입력해 주세요",
      "password is not correct": "비밀번호를 입력해 주세요(6-20자리 숫자 혹은 영문 알파벳)",
      "authCode is required": "인증번호를 입력해 주세요"
    },
    "loginMore": {
      "Remember account": "아이디 저장",
      "retrieve": "비밀번호 찾기？",
      "register": "注册账号"
    },
    "loginBtn": "로그인",
    "logging": "正在登陆"
  },
  "retrieve": {
    "title": {
      "s1": "계좌번호가 없습니다？",
      "s2": "등록해 주십시오"
    },
    retrieve: "비밀번호 찾기",
    retrieveType: {
      type1: "핸드폰으로 비밀번호 찾기",
      type2: "이메일로 비밀번호"
    },
    "form": {
      "mobile": {
        "name": "手机号",
        "placeholder": "회원가입한 핸드폰번호를 입력해"
      },
      "email": {
        "name": "邮箱",
        "placeholder": "등록시 작성한 이메일 주소를 입력해 주세요"
      },
      "picCode": {
        "name": "图形验证",
        "placeholder": "그래픽 검증 코드를 입력해 주세요"
      },
      "authCode": {
        "name": "验证码",
        "placeholder": "인증번호를 입력해 주세요"
      },
      "resetPsd": {
        "name": "重置密码",
        "placeholder": "초기화 비밀번호를 입력해 주세요 : 6자리부터 20자리까지"
      },
      "confirmPsd": {
        "name": "确认密码",
        "placeholder": "재설정할 비밀번호를 다시 확인해 주세요"
      }
    },
    "rulesErr": {
      'mobile is required': "핸드폰 번호를 입력해 주세요",
      "mobile is not correct": "핸드폰번호가 정확하지 않습니다",
      "picCode is required": "그래픽 검증 코드를 입력해 주세요",
      "authCode is required": "인증번호를 입력해 주세요",
      "resetPsd is required": "초기화 비밀번호를 입력해 주세요 : 6자리부터 20자리까지",
      "confirmPsd is required": "재설정할 비밀번호를 다시 입력해 주세요",
      "psdNumber is not correct": "초기화 비밀번호를 입력해 주세요 : 6자리부터 20자리까지",
      "inconsistent password": "비밀번호가 일치하지 않습니다",
      "email is required": "등록시 작성할 이메일 주소를 입력해 주세요",
      "email is not correct": "정확한 이메일주소를 입력해 주세요"
    },
    "authBtn": "인증번호 획득",
    "resetPsdBtn": "비밀번호 재설정"
  },
  /*---------------------------   注册页     --------------------------*/
  "register": {
    'Welcome to register': "회원가입 환영합니다",
    "title": {
      "s1": "아이디가 있으시면？",
      "s2": "로그인 하세요"
    },
    "form": {
      "mobile": {
        "name": "手机号",
        "placeholder": "핸드폰 번호 11자리 입력해 주세요"
      },
      "picCode": {
        "name": "图形验证",
        "placeholder": "그래픽 검증 코드를 입력해 주세요"
      },
      "authCode": {
        "name": "验证码",
        "placeholder": "인증번호를 입력해 주세요"
      },
      "email": {
        "name": "邮箱",
        "placeholder": "이메일주소를 입력해주세요"
      },
      "password": {
        "name": "密码",
        "placeholder": "비밀번호를 입력해 주세요(6-20자리 숫자 혹은 영문 알파벳)"
      },
      "confirmPsd": {
        "name": "重复密码",
        "placeholder": "설정하신 비밀번호를 다시 입력하십시오"
      }
    },
    "rulesErr": {
      'mobile is required': "핸드폰 번호를 입력해 주세요",
      "mobile is not correct": "핸드폰번호가 정확하지 않습니다",
      "picCode is required": "그래픽 검증 코드를 입력해 주세요",
      "authCode is required": "인증번호를 입력해 주세요",
      "password is required": "비밀번호를 입력해 주세요",
      "confirmPsd is required": "비밀번호를 다시 입력해 주세요",
      "psdNumber is not correct": "비밀번호를 입력해 주세요(6-20자리 숫자 혹은 영문 알파벳)",
      "inconsistent password": "비밀번호가 일치하지 않습니다",
      "email is required": "이메일주소를 입력해주세요",
      "email is not correct": "邮箱格式不正确",
      "protocol is required": "请先同意注册协议"
    },
    "agreement": {
      "s1": "회원가입",
      "s2": "이용약관 동의"
    },
    "registerBtn": "가입하기",
    "loading": "가입하기",
    "authBtn": "인증번호 획득"
  },
  /*---------------------------   修改密码    --------------------------*/
  "changePsd": {
    "form": {
      "oldPsd": {
        "name": "旧密码",
        "placeholder": "请输入旧密码"
      },
      "newPsd": {
        "name": "新密码",
        "placeholder": "请输入新密码"
      },
      "confirmPsd": {
        "name": "新密码",
        "placeholder": "请再次输入新密码"
      },
      "authCode": {
        "name": "验证码",
        "placeholder": "请输入验证码"
      },
    },
    "rulesErr": {
      "oldPsd is required": "请输入原密码",
      "newPsd is required": "请输入新密码",
      "confirmPsd is required": "请再次输入新密码",
      "authCode is required": "请输入验证码",
      "psdNumber is not correct": "请填写6至20位密码",
      "inconsistent password": "비밀번호가 일치하지 않습니다",
    },
    "cancelBtn": "取消",
    "confirmBtn": "确定"
  },
  /*首页*/
  index: {
    navTitle: {
      title1: "公告事项",
      title2: "新闻中心",
      title3: "旅游信息",
    },
    consulting: "뉴스",
    Notice: "공지사항",
    procedures: {
      procedures: "비자신청절차 ",
      'Add Applicants': "신청인 추가",
      'Fill in the information': "자료 작성",
      'Postal information entry': "우편정보 기입",
      'Confirm and pay': "확인 지불",
      'Waiting for the visa': "비자 발급 대기",
      'Visa application result': "방문 or 택배방식 여권 교부"
    },
    visaCenter: '대한민국온라인비자신청센터',
    'Consulate information': "영사관정보",
    'Convenient service': "서비스 안내",
    service: {
      'division of jurisdictions': "관할구역 구분",
      'Visa application form download': "비자신청서 다운",
      'Common problems': "자주 묻는 질문",
      'Other materials download': "기타 서류 다운",
    },
    link: "사이트 링크"
  },
  footer: {
    'reminder': '깨우치다：본 사이트 (PC 단, 애플릿, 퍼블릭 번호) 에서 사용한 한국 관광지의 사진 및 관련정보는 전부 한국관광공사에서 제공.',
    'About us': "회사소개",
    'Contact us': "연락방식",
    'feedback': "의견 피드백",
    'business cooperation': "비즈니스 합작",
    'App download': "App 다운로드",
    'Site map': "사이트맵",
    'User agreement': "이용약관",
  },
  /*---------------------------   个人中心     --------------------------*/
  "center": {
    "userMsg": "정보 센터",
    "orderList": "예약관리",
    "applyTodoList": "신청 중",
    "address": "상용주소",
    "invoiceTitle": "영수증신청",
    "feedback": "의견 피드백",
    "logout": "로그아웃",
    "changePhone": "更换手机",
    "changePsd": "修改密码",
    "setting": "设置",
    logoutNotice: "로그아웃 하시겠습니까?",
    'Working days': "근무일"
  },
  aboutUs: {
    'HOME': "메인",
    'Site map': "사이트맵",
    'About us': "우리에 대해",
    'Contact us': "연락방식",
    'Business cooperation': "비즈니스 협력",
  },
  /*---------------------------   消息中心     --------------------------*/
  "userMsg": {
    "navTitle": {
      "title1": "系统消息",
      "title2": "公告消息"
    }
  },
  /*---------------------------   签证中心     --------------------------*/
  "visaCenter": {
    "Working hours and contact information": '근무시간 및 연락처',
    "Visa fee description": '비자비용 설명',
  },
  /*---------------------------   我的订单     --------------------------*/
  "orderList": {
    title: "주문서",
    Name: "성명",
    to: "to",
    'Passport no': "여권번호",
    'jurisdictions': "관할지역",
    'Express service1': "우편 서비스",
    'Id card number': "신분증번호",
    'Application date': "신청일자",
    'Sub account': "서브계정",
    'Express service2': "우편 서비스",
    'Mobile phone no': "휴대폰 번호",
    'Creation time': "만든 시간",
    'The order number': "주문번호",
    'Order Amount': "주문서 금액",
    'Send a single number': "송장번호",
    'The name': "성명",
    'To apply for the jurisdictions': "신청 지역",
    'state': "상태",
    'operation': "조작",
    "navTitle": {
      "title1": "全部订单",
      "title2": "进行中",
      "title3": "已完成"
    },
    "orderItem": {},
    nav1: "메인",
    nav2: "개인 센터",
    nav3: " 예약관리",
    screening: "선별",
    empty: "비우기",
    "view": "보기",
    "Expand": "펼쳐보기",
    "Check the invoice": "영수증 보기",
    "To apply for the invoice": "영수증 신청",
    "To apply for the invoice1": "개표 중",
    "To apply for the invoice2": "청구서 다운로드",

    "Profile picture": "증명사진",
    "Name/pinyin": "이름/병음",
    "Passport number": "여권번호",
    "Gender": "성별",
    "Application type": "신청유형",
    "Domicile place": "호적 소재지",
    "Reply mode": "리턴방식",
    "Application status": "신청 상태",


    "Start date": "시작일",
    "end date": "종료일"
  },
  /*---------------------------   订单详情     --------------------------*/
  "orderDetail": {
    "use one mailing address1": "아래1",
    "use one mailing address2": "명 한 주소로 보냅니다",
    "The recipient": "받는 사람", "Mobile phone number": "휴대폰번호", "address": "주소",
    "Visa fee（consulate charges）": "비자비용(한국영사관에서 받음)",
    "Visa service charge（Visa center charges）": "비자 서비스 비용(비자센터에서 받음)",
    "The urgent charge": "급행비용(한국영사관에서 받음)",
    title: "예약 정보",
    nav1: "메인",
    nav2: "개인 센터",
    nav3: "예약관리",
    "The order number": "예약번호",
    "Creation time": "만든 시간",
    "Check the application form": "신청서 보기",
    "Delivery charge": "택배 비용",
    "Delivery check": "택배 조회",
    "return express fee": "리턴 택배 비용",
    "Click to view the required materials": "필요한 자료 클릭해서 보기",
    "Send the required materials to the e-mail": "필요한 자료 이메일로 보기",
    "The payment information": "결제정보",
    "Payment amount": "결제 금액",
    "payment": "결제하기",
    "payment method": "결제 방식",
    "Payment time": "결제 시간",
    "navTitle": {
      "title1": "签证详情",
      "title2": "快递详情"
    },
  },
  /*---------------------------   待办申请列表     --------------------------*/
  "applyTodoList": {
    title: "신청 중",
    "Waiting list": "대기신청 목록",
    "attention": "주의: 같은 영사구역만 함께 주문할수 있습니다",
    "maximum": "동시에 주문한 신청서류는 같은 방식으로 센터에 전달합니다(최고로 5명 신청가능)",
    "Please select an applicant": "신청인을 선택하세요",
    'Visa procedures': "비자신청절차 ",
    'Add Applicants': "신청인 추가",
    'Fill in the information': "자료 작성",
    'Fill in the mailing information': "우편정보 입력",
    'Confirm and pay': "확인 및 지불",
    'Waiting for the visa': "비자 발급 대기 ",
    'Pick up or send visa results': "방문 or 택배방식 여권 교부",
    "s1": "办签流程",
    confirmBtn: "确认并下单",

  },
  /*---------------------------   消息列表     --------------------------*/
  msgList: {
    'Message center': "정보 센터",
    'System message': "시스템 메세지",
    'Notice': "공지사항",
  },
  /*---------------------------   发票抬头     --------------------------*/
  invoiceList: {
    title: "영수증이름",
    'Add receipt name': "영수증이름추가",
    'type': "유형",
    'Contact phone number': "연락처",
    'email': "이메일",
    'Invoice name': "영수증이름",
    'other': "기타",
    'operation': "조작",
  },
  /*---------------------------   意见反馈     --------------------------*/
  feedback: {
    nav1: "메인",
    nav2: "개인 센터",
    'title': "의견 피드백",
    'Feedback information': "피드백 정보",
    "Submit feedback": "피드백 제출",
    "Over 6 words": "6자 이상, 200자 이내",
  },
  /*---------------------------   地址列表     --------------------------*/
  addressList: {
    title: "현주소",
    'Add new address': "새 주소 추가",
    'The recipient': "받는 사람",
    'region': "소재지",
    'Detailed address': "상세 주소",
    'Mobile phone number': "휴대폰 번호",
    'operation': "조작",
  },
  /*---------------------------   签证申请类型页面     --------------------------*/
  choiceVisaType: {
    "WeChat customer service": '위챗공식계정',
    "contact number": '대표번호',
    "Email consultation": '메일주소',
    "Official website": '홈페이지',

    "Select visa center": '비자센터 선택',
    "Select visa center tips": '비자센터를 선택하면 현재 비자센터가 수리하고 있는 상주 생활 업무 도시를 표시할 수 있다.(상주 생활 업무 도시는 현지에서 사회보장이나 거주카드를 가지고 있음)',
    "Purpose of visit": '방문목적',
    "Type of visa": '비자종류',
    "Issued to": '발급대상',
    "Do you need help": '도움이 필요하신가요?',
    "View Example": '샘플보기',
    "Download files": '서식다운로드',
    "On line printing and filling": '온라인 작성 및  출력',
    "Description of Expenses": "수수료 안내",
    "Visa fee（consulate charges）": "비자수수료(주중한국공관 수납)",
    "Visa service charge（Visa center charges）": "센터수수료(비자신청센터 수납)",
    "The urgent charge": "급행수수료(주중한국공관 수납)",
    "Click to view the required materials": "필요한 자료 클릭해서 보기",
    "Send the required materials to the e-mail": "필요한 자료 이메일로 보기",
    "Urgent or not": '급행여부',
    "attention": "주의",
    "urgent service1": "급행은 ",
    "urgent service2": "위안/인",
    "Visa Description": "사증안내",
    "The urgent is only based": "급행은 서류검토만 우선순위이고 비자 발급 시간 및 비자성공율과는 관계가 없습니다",
    "Application Form fill in type": "신청서 작성 방식",
    "Apply": "신청하기",
    title: "비자신청",
    "container": {
      "s1": "韩国签证申请中心",
    },
    confirmBtn: "신청 시작",
    form: {
      letter: {
        s1: '본인은',
        s2: '《개인정보보호고지서》',
        s3: '와',
        s4: '《사용자프라이버시정책》',
        s5: '의 모든 내용을 충분히 이해하고 숙지 하였으며, ',
        s6: '사증신청에 필요한 각종 정보와 증명서류등의 원본 및 사본을 제출하는 것에 동의합니다.',
      },
      mode: {
        name: '주의 사항：',
        s1: '1. 신청인은 반드시 사실에 근거하여 빠짐없이 정확하게 신청서를 작성해야 합니다.',
        s2: '2. 반드시 온라인으로 작성완료한 신청서를 출력하여 구비서류와 함께 제출해야 합니다',
        s3: '3. 사증심사를 위해 필요한 경우 총영사관에서 추가서류 제출을 요구할 수 있으며,신청인 등에 대해 면담을 실시할 수 있습니다.',
        s4: '4. 신분증,호구부,결혼증 등 개인 신분 서류나 원본사진 등 보조자료는 접수(심사)후 원본을 반환하나,기타 제출된 서류는 반환하지 않습니다',
        s5: '5. 사증발급 신청 수수료는 접수가 이루어진 이후에는 환불이 불가능 한점 유의해 주시기 바랍니다.',
      },
      location: {
        name: "상주지/근무지를 선택하세요",
        s1: "最终受理领区要以常住生活工作城市为准，即：在当地拥有社保或居住卡为准。",
        s2: "您的申请将提交到"
      },
      'Visa type': "비자유형",
      'Visa entries': "비자횟수",
      'The urgent': "급행",
      'Required materials': "필요서류",
      type: {
        name: "选择签证类型"
      },
      period: {
        name: "选择有效期",
        s1: "사증종류：",
        s2: "채류기간：",
        s3: "유효기간：",
        s4: "심사일：",
      },
      expedited: {
        normal: "일반사증 신청",
        expedited: "급행사증 신청"
      },
      urgent: {
        name: "주의 사항：",
        s1: "급행사증 시청시 급행 수수료",
        s2: "위안/인을 추가로 지불하여야 합니다.",
        s3: "급행사증 심사 소요기간은 근무일 기준 3일 입니다.",
        s4: "급행사증 신청시 택배 서비스를 사용할 수 없습니다.",
      },
      datum: {
        name: "구비서류",
        button: "所需资料发送到邮箱"
      }
    },
    rulesErr: {
      "locationValue is required": "请选择常住生活/工作所在地",
      "visaTypeValue is required": "请选择签证类型",
      "visaProductValue is required": "请选择有效期"
    }
  },
  savePassport: {
    "upload a passport photo": "여권사진 업로드",
    "View sample image": "샘플사진 보기",
    "If it is not China, please fill in manually": "중국이 아닐 경우 수기로 입력해 주세요",
    container: {
      s1: "以下内容为自动识别内容，请仔细检查，如有问题可直接修改",
    },
    form: {
      passportNum: {
        name: "여권번호",
        placeholder: "",
      },
      surnameZh: {
        name: "이름 (중국어)",
        placeholder: ""
      },
      nameZh: {
        name: "이름(중국어)",
        placeholder: ""
      },
      surnameEn: {
        name: "성(영문)",
        placeholder: ""
      },
      nameEn: {
        name: "이름(영문)",
        placeholder: ""
      },
      gender: {
        name: "성별",
        male: '남',
        female: '여'
      },
      birthDate: {
        name: "생년월일",
        placeholder: "날짜 선택"
      },
      birthPlaceZh: {
        name: "출생지",
        placeholder: ""
      },
      birthPlaceEn: {
        name: "출생 국가",
        placeholder: ""
      },
      issuancePlaceZh: {
        name: "발급처",
        placeholder: ""
      },
      issuancePlaceEn: {
        name: "签发地点（英文）",
        placeholder: ""
      },
      issuanceDate: {
        name: "발급날짜",
        placeholder: "날짜 선택"
      },
      issuancePeriod: {
        name: "여권만료일",
        placeholder: "날짜 선택"
      },
    },
    "rulesErr": {
      'passportNum is required': "여권번호를 입력해 주세요",
      'requiredCount': "길이가 #num# 자를 초과해서는 안됩니다.",
      "surnameZh is required": "이름을 입력하십시오. (중국어)",
      "surnameEn is required": "성(영문)  을 입력해주세요",
      "nameZh is required": "이름(중국어)을 입력해주세요",
      "nameEn is required": "이름(영문)을 입력해주세요",
      "surnameEn is not correct": "姓（英文）不正确",
      "nameEn is not correct": "名（英文）不正确",
      "birthPlaceZh is required": "출생지를 입력해 주세요",
      "passportSex is required": "请选择性别",
      "birthPlaceEn is required": "请填写出生国家",
      "issuancePlaceZh is required": "발급처를 입력해 주세요",
      "issuancePlaceEn is required": "请填写签发地点（英文）",
      "birthDate is required": "생년월일을 선택해 주세요",
      "issuanceDate is required": "발급날짜를 선택해 주세요",
      "issuancePeriod is required": "여권만료일 선택해 주세요",
      "date is not correct": "结束时间不能早于开始时间"
    },
    reUploadBtn: "重新上传",
    save2next: "保存，并下一步"
  },
  uploadIdCardFront: {
    "Upload id card": "신분증 업로드",
    "attention": "주의: 신분증사진이 선명하지 않을 경우 식별이 어려우니 각별히 조심해서 체크해 주세요. 신분증을 발급받지 않은 미성년일 경우 출생의학증명서를 업로드 해 주세요.",
    "Upload id card front": "신분증 앞면 업로드",
    desc: "以下内容为自动识别内容，请仔细检查，如有问题可直接修改",
    form: {
      name: {
        title: "이름",
        placeholder: "이름을 입력해 주세요"
      },
      gender: {
        title: "성별",
        value1: "남",
        value2: "여",
      },
      nation: {
        title: "민족",
        placeholder: "민족을 입력해 주세요"
      },
      birthDay: {
        title: "생년월일",
        placeholder: "날짜 선택"
      },
      address: {
        title: "주소",
        placeholder: "주소를 입력해 주세요"
      },
      idCardNo: {
        title: "신분증 번호",
        placeholder: "신분증 번호를 입력해 주세요"
      },
      reUploadBtn: "重新上传",
      save2nextBtn: "下一步"
    },
    rulesErr: {
      "name is required": "이름을 입력해 주세요",
      'idcardNumber': "정확한 ID 번호를 입력하십시오",
      "gender is required": "请选择性别",
      "nation is required": "민족을 입력해 주세요",
      "birthDate is required": "생년월일을 선택해 주세요",
      "address is required": "주소를 입력해 주세요",
      "idCardNo is required": "신분증 번호를 입력해 주세요",
    }
  },
  uploadIdCardBack: {
    "Minorchild, did not handle id card": "미성년자, 주민등록 미발급",
    desc: "以下内容为自动识别内容，请仔细检查，如有问题可直接修改",
    "Upload id card back": "신분증 뒷면 업로드",
    "Minor child, did not handle id card": "미성년아동, 신분증 미 발급",
    "attention": "주의: 신분증을 발급받지 않은 미성년 일 경우 우편물재료에 출생의학증명원본과 사본을 제공하고 원본사진을 업로드 해주세요",
    "Upload medical certificate of birth": "출생의학증명원본 업로드",
    form: {
      datePlaceholder: "날짜 선택",
      idcardAuthority: {
        title: "발급 기관",
        placeholder: "Please fill in the issuing authority"
      },
      cardNumber: {
        title: "신분증 번호",
        placeholder: "신분증 번호를 입력해 주세요"
      },
      idcardDate: "만료일",
      idcardForever: "장기 유효 신분증",
      longEffective: "장기적 효과"
    },
    rulesErr: {
      "idcardAuthority is required": "발급 기관을 입력해 주세요",
      "idcardStartDate is required": "시작 날짜를 선택하십시오",
      "idcardEndDate is required": "종료 날짜를 선택하십시오",
      "date is not correct": "结束日期不能早于开始日期",
    }
  },
  uploadAvatar: {
    "Upload ID picture": "증명사진 업로드",
    "attestation photo manual": "증명 사진 설명서:",
    "desc1": "1、최근 6개월 사이에 찍은 2인치 흰 바탕의 컬러 사진;",
    "desc2": "2、우편으로 보내는 사진과 업로드한 사진은 일치해야 합니다。",
    "desc3": "3、안경을 착용하거나 액세서리를 착용해서는 안되며 유니폼을 착용해서는 안됩니다. 두 눈은 카메라를 똑바로 바라보고 두 귀를 드러내고 입을 다물면 안되며 머리카락은 두눈을 가리면 안됩니다. 좌우 어깨는 평형을 유지해야 합니다;",
    "desc4": "4、용모 변화, 사진색 변색 혹은 퇴색 등의 원인으로 인해 현재의 용모와 뚜렷한 차이가 생겨서는 안 됩니다。",
    "desc5": "*셀프 촬영 및 인쇄 서비스를 제공하고 있으니 주문하실 때 선정하시기 바랍니다",
    "Check it and go to the next page": "확인 마친 후 다음으로 이동"
  },
  bankCard: {
    "Upload ID picture": "Upload ID picture",
    "attestation photo manual": "attestation photo manual:",
    "desc1": "1、2 white background color photos taken in the last 6 months;",
    "desc2": "2、Photos sent by mail and uploaded photos must match。",
    "desc3": "3、Do not wear glasses, exaggerated jewelry or uniforms. Look straight into the camera with both eyes; Show your ears; Mouth closed; Hair can not cover the eyes; Balance your left and right shoulders;",
    "desc4": "4、Cannot be appearance changed, photograph discoloration, fade wait for a reason, with present appearance produce apparent difference。",
    "desc5": "*We provide photo self-shooting and printing service, please choose when you order",
    "Check it and go to the next page": "Check it and go to the next page"
  },
  savePersonalInfo: {
    title: "개인 정보",
    attention: "신청서를 작성할 때 실제 유효한 정보를 기입해 주십시오, 그렇지 않으면 비자 발급이 거절될수 있습니다",
    "question1": "*기타 이름으로 입국했거나 한국에서 출국한 적이 있습니까？",
    "surnameZh": "기타 이름 (성)",
    "nameZh": "기타 이름(이름)",
    "question2": "*이중국적을 갖고 있습니까？",
    "orderNationality": "*다른 나라 국적",
    "surnameZhPlaceholder": "기타 성을 입력해 주세요",
    "nameZhPlaceholder": "기타 이름을 입력해 주세요",
    "orderNationalityPlaceholder": "국가 이름을 입력하십시오",
    "question3": "*다른 여권을 소지하고 계십니까？",
    "question4": "*기타 여권 종류",
    "passportType": {
      "type1": "외교관 여권",
      "type2": "공무 여권",
      "type3": "일반 여권",
      "type4": "기타"
    },
    "passportNum": {
      name: "*여권번호",
      placeholder: "여권번호를 입력해 주세요"
    },
    "issuancePlace": {
      name: "*발급국가",
      placeholder: "발급국가를 입력해 주세요"
    },
    issuancePeriod: {
      name: "*유효 기간",
      placeholder: "만료일을 선택하십시오"
    },
    "issuanceOrg": {
      name: "*签发机关",
      placeholder: "请输入签发机关"
    },
    rulesErr: {
      "usedOtherName is required": "请选择是否曾用名",
      "holdOtherCountry is required": "请选择是否拥有双重国籍",
      "holdOtherPassport is required": "请选择是否拥有其他护照",
      "surnameZh is required": "기타 성을 입력해 주세요",
      "nameZh is required": "기타 이름을 입력해 주세요",
      "orderNationality is required": "국가 이름을 입력하십시오",
      "passportNum is required": "여권번호를 입력해 주세요",
      "issuancePlace is required": "발급국가를 입력해 주세요",
      "issuancePeriod is required": "만료일을 선택하십시오",
      "issuanceOrg is required": "请输入签发机关",
      "otherPassportType is required": "请选择护照类型",
    },
    "yes": "네",
    "no": "아니요",
    "save2nextBtn": "保存，并下一步"
  },
  SaveContactInfo: {
    title: "연락처 정보",
    description: "填写申请表时，请填写真实有效信息，否则将导致拒签",
    address: "*본국 주소",
    addressPlaceholder: "상세한 주소를 입력해 주십시오",
    nowAddress: "*현 거주지",
    desc: "현거주지와 본국 주소가 다를 경우 입력해 주세요",
    nowAddressPlaceholder: "현 거주지를 입력해 주십시오",
    mobile: "*휴대폰번호",
    mobilePlaceholder: "휴대폰번호를 입력해 주십시오",
    telephone: "*전화번호",
    telephonePlaceholder: "전화번호를 입력해 주십시오",
    email: "*이메일",
    emailPlaceholder: "이메일 주소를 입력해 주세요",
    "Emergency contact information": "긴급 연락처 정보",
    "The surname": "성(영문)",
    "Name": "이름(영문)",
    "Please enter the last name of the emergency contact": "긴급 연락인의 성을 입력해 주세요",
    "Please enter the name of the emergency": "긴급 연락인의 이름을 입력해 주세요",
    emergencyContact: "*긴급 연락처",
    contactName: "*The surname(English) ",
    contactNamePlaceholder: "긴급 연락인의 성을 입력해 주세요",
    contactMobile: "*전화번호",
    contactMobilePlaceholder: "긴급 연락인의 전화번호를 입력해 주세요",
    contactNationValuePlaceholder: "긴급 연락인의 거주국가를 입력해 주세요",
    emergencyRelationshipPlaceholder: "신청인과의 관계를 입력해 주세요",
    contactNation: "*거주국",
    contactRelation: "*신청인과의 관계",
    save2nextBtn: "保存，并下一步",
    rulesErr: {
      "address is required": "상세한 주소를 입력해 주십시오",
      "nowAddress is required": "현 거주지를 입력해 주십시오",
      "mobile is required": "휴대폰번호를 입력해 주십시오",
      "telephone is required": "전화번호를 입력해 주십시오",
      "email is required": "이메일 주소를 입력해 주세요",
      "contactName is required": "긴급 연락인의 성을 입력해 주세요",
      "contactMobile is required": "긴급 연락인의 전화번호를 입력해 주세요",
      "contactNationValue is required": "긴급 연락인의 거주국가를 입력해 주세요",
      "contactRelationValue is required": " 신청인과의 관계를 입력해 주세요",
    }
  },
  saveMemberInfo: {
    title: "가족 정보",
    maritalStatus: {
      title: "*혼인여부",
      status1: "기혼",
      status2: "이혼",
      status3: "미혼",
    },
    spouseInfo: {
      title: "*배우자 정보",
      surnameZh: "성(영문)",
      surnameZhPlaceholder: "배우자의 성을 입력해 주세요",
      nameZh: "이름(영문)",
      nameZhPlaceholder: "배우자의 이름을 입력해 주세요",
      birthDate: "*생년월일",
      birthDatePlaceholder: "생년월일을 선택해 주세요",
      nationality: "*국적",
      nationalityPlaceholder: "국적을 입력해 주세요",
      mobile: "*전화번호",
      mobilePlaceholder: "배우자 전화번호를 입력해 주세요",
      address: "*거주지 주소",
      addressPlaceholder: "거주지 주소를 입력해 주세요"
    },
    haveChild: {
      question: "*자녀 유무?",
      yes: "네",
      no: "아니요",
      childrenCount: {
        title: "자녀 인원수",
        placeholder: "자녀의 개수를 입력하십시오",
      }
    },
    rulesErr: {
      "surnameZh is required": "배우자의 성을 입력해 주세요",
      "marital is required": "请选择婚姻状况",
      "nameZh is required": "배우자의 이름을 입력해 주세요",
      "birthDate is required": "생년월일을 선택해 주세요",
      "contactNationValue is required": "국적을 입력해 주세요",
      "mobile is required": "배우자 전화번호를 입력해 주세요",
      "address is required": "거주지 주소를 입력해 주세요",
      "childrenCount is required": "자녀의 개수를 입력하십시오",
      "haveChild is required": "请选择是否有子女",
    },
    save2nextBtn: "保存，并下一步"
  },
  saveEducationInfo: {
    title: "교육 정보",
    "Professional information": "직업 정보",
    educationBg: {
      title: "*최고 학력",
      value1: "석사/박사",
      value2: "학사",
      value3: "고등학교",
      value4: "기타",
    },
    otherEducationBg: "*기타 학력 설명해 주세요",
    educationDescriptionPlaceholder: "기타 학력 설명을 입력해 주세요",
    universityNamePlaceholder: "학교 명칭을 입력하십시오",
    universityPlacePlaceholder: "학교 소재지를 입력해 주십시오",
    schoolName: "*학교 명칭",
    schoolLocation: "*학교 소재지",
    profession: {
      title: "*현재 직업",
      value1: "기업가",
      value2: "자영업",
      value3: "회사원",
      value4: "공무원",
      value5: "학생",
      value6: "무직",
      value7: "퇴직",
      value8: "기타",
    },
    occupationDescription: "*기타 직업 설명",
    occupationDescriptionPlaceholder: "기타 직업 설명을 입력해 주세요",
    organizationName: "*회사/기관/학교 명칭",
    organizationNamePlaceholder: "회사/기관/학교 명칭을 입력해 주세요",
    organizationPosition: "*직업/커리큘럼",
    organizationPositionPlaceholder: "직업/커리큘럼을 입력해 주세요",
    organizationAddress: "*회사/기관/학교 주소",
    organizationAddressPlaceholder: "회사/기관/학교 주소를 입력해 주세요",
    organizationPhone: "*회사/기관/학교 연결 전화",
    organizationPhonePlaceholder: "회사/기관/학교 연결 전화를 입력해 주세요",
    otherProfession: "*其它职业，请说明",
    save2nextBtn: "保存，并下一步",
    rulesErr: {
      "education is required": "请选择学历",
      "occupation is required": "请选择职业",
      "educationDescription is required": "기타 학력 설명을 입력해 주세요",
      "universityName is required": "학교 명칭을 입력하십시오",
      "universityPlace is required": "학교 소재지를 입력해 주십시오",
      "occupationDescription is required": "기타 직업 설명을 입력해 주세요",
      "organizationName is required": "회사/기관/학교 명칭을 입력해 주세요",
      "organizationPosition is required": "직업/커리큘럼을 입력해 주세요",
      "organizationAddress is required": "회사/기관/학교 주소를 입력해 주세요",
      "organizationPhone is required": "회사/기관/학교 연결 전화를 입력해 주세요",
    },

  },
  saveAccessInfo: {
    title: "방문 정보",
    Application: {
      title: "*입국 신청 사유",
      value1: "여행/경유 여행/경유",
      value2: "회의 등 행사 참가",
      value3: "의료 관광",
      value4: "단기 비즈니스",
      value5: "학습/트레이닝",
      value6: "취업 활동",
      value7: "무역/투자/주재원",
      value8: "친척 방문/친구 방문",
      value9: "결혼/이민",
      value10: "외교/공무",
      value11: "기타",
      other: "기타 입국 사유",
      otherPlaceholder: "기타 입국 사유를 입력해 주세요"
    },
    access: {
      "days of detention": {
        title: "*체류일수",
        value1: "90일(포함) 이하",
        value2: "91일(포함) 이상",
        value3: "영구",
      },
      "Date of departure": "출국 날짜",
      date: "*입국 예정일",
      datePlaceholder: "입국 예정일",
      days: "*拟滞留天数",
      mobile: "*한국 내 전화번호",
      address: "*한국 내 체류 주소/호텔"
    },
    families: {
      question: "*동행하는 가족분이 있습니까？",
      yes: "네",
      no: "아니요",
      family: {
        surname: "성(영문)",
        Name: "이름(영문)",
        birth: "생년월일",
        nationality: "국적",
        Relationship: "신청인과의 관계",
      },
      error: {
        surname: "영문 성을 입력해 주세요",
        surnameErr: "请输入正确的英文姓",
        Name: "영문 이름을 입력해 주세요",
        NameErr: "请输入正确的英文名",
      },
      "Add fellow pedestrians": "동행자 추가"
    },
    records: {
      question1: "*최근 5년 동안 한국을 방문 한 적이 있습니까？",
      "Purpose of recent visit": "최근 방문한 목적",
      "Visit purpose": "방문목적",
      "During the visit": "방문기간",
      count: "*五年内访韩次数",
      purpose: "*近期入境目的",
      question2: "*최근 5년 동안 한국 외 다른 국가를 방문한 적이 있습니까？",
      countries: {
        title: "其它访问国家",
        name: "*국가 명칭 (영문) ",
        purpose: "*방문 목적",
        period: "방문 기간"
      },
      dateStartPlaceholder: "시작 시간",
      dateEndPlaceholder: "마감 시간",
      yes: "네",
      no: "아니요",
      "Add Access Log": "방문 기록 추가",
      "Add Visiting Country": "방문한 국가 추가",
    },
    haveInKorea: {
      question: "*한국에 거주하는 가족이 있습니까？",
      family: {
        title: "在韩家属",
        familyName: "*성명(영문)",
        familyBirthDate: "*생년월일",
        familyCountry: "*국적",
        familyRelationship: "*신청인과의 관계"
      },
      yes: "네",
      no: "아니요",
      nameErr: "请输入正确的英文姓名",
      "Add family members living in Korea": "한국에 계시는 가족 추가",
      relationship: {
        value1: "배우자",
        value2: "자녀",
        value3: "부모",
        value4: "형제 자매",
      }
    },
    rulesErr: {
      "date is required": "입국 예정일을 입력해 주세요",
      "phone is required": "0-9 숫자 만 허용",
      "days is required": "请填写拟滞留天数",
      "mobile is required": "한국 내 전화번호를 입력해 주세요",
      "address is required": "한국 내 체류 주소/호텔를 입력해 주세요",
      "name is required": "请填写同行家属姓名",
      "birthDate is required": "동행가족 생년월일을 선택해 주세요",
      "country is required": "동행 가족의 국적을 입력해 주세요",
      "relationship is required": "请选择与同行家属关系",
      "visitedValue is required": "请选择近五年是否访问过韩国",
      "visitedPurposeValue is required": "최근 방문한 목적을 입력해 주세요",
      "visitedTimes is required": "请输入近期访问次数",
      "hadVisitedOther is required": "请选择是否访问过除韩国外的其他国家",
      "countryName is required": "请选择国家",
      "visitedPurpose is required": "방문목적을 입력해 주세요",
      "visitedCountry is required": "방문 한 국가를 입력해 주세요",
      "dateStart is required": "시작한 시간을 선택해 주세요",
      "dateEnd is required": "마감 시간을 선택해 주세요",
      "haveFamily is required": "请选择是否有同行家属",
      "haveInKorea is required": "请选择是否有家属在韩居住",
      "familyName is required": "한국에 계시는 가족분 성명을 입력해 주세요",
      "familyBirthDate is required": "한국에 계시는 가족분 생년월일을 선택해 주세요",
      "familyCountry is required": "한국에 계시는 가족분의 국적을 입력해 주십시오",
      "familyRelationship is required": "请选择在韩家属与申请人关系",
      "date is not correct": "结束日期不能早于开始日期",
      "Please enter other Immigration Arrangements": "기타 입국 사유를 입력해 주세요",
      "Please select a date to go abroad": "출국 날짜를 선태해 주세요",
      "Please enter your purpose of recent visit": "최근 방문한 목적을 입력해 주세요"
    },
    save2nextBtn: "保存，并下一步"
  },
  saveOtherInfo: {
    invitation: {
      title: "초청 관련 정보",
      question: "*한국에 초청인이나 초청업체가 있습니까？",
      yes: "네",
      no: "아니요",
      name: "*초청인 성명 또는 초청업체 명칭",
      info: "*초청인 출생일 또는 초청업체 사업자 등록증 번호",
      contactRelation: "*신청인과의 관계",
      invitedAddress: "*초청인 또는 초청업체 주소",
      mobile: "*전화번호",
      invitedRelationship: "*邀请人与申请人的关系"
    },
    cost: {
      title: "비용 정보",
      question: "*谁将承担在韩国期间的费用",
      value1: "自己",
      value2: "邀请方",
      value3: "他人支付",
      paymentType: "*결제 유형",
      cost: "*한국 내 체류기간 동안 비용(달러 기준)",
      payerName: "*성함/회사 (또는 단체) 명칭",
      payerRelationship: "*비용결제자와 신청인의 관계",
      "phone number": "*전화번호"
    },
    assist: {
      title: "서류작성도움자 정보",
      question: "*본 신청서 작성에 도와준 분이 있습니까",
      yes: "네",
      no: "아니요",
      name: "*이름",
      birthDate: "*생년월일",
      mobile: "*전화번호",
      contactRelation: "*신청인과의 관계",
      birthDatePlaceholder: "생년월일"
    },
    rulesErr: {
      "haveInvited is required": "请选择是否在韩国有邀请人或邀请单位",
      "invitedName is required": "초청인 성명 또는 초청업체 명칭을 입력해 주세요",
      "invitedInfo is required": "초청인 출생일 또는 초청업체 사업자 등록증 번호를 입력해 주세요",
      "invitedAddress is required": "초청인 또는 초청업체 주소를 입력해 주세요",
      "invitedContact is required": "초청인의 전호번호를 입력해 주세요",
      "invitedRelationship is required": "신청인과의 관계를 입력해 주세요",
      "payType is required": "결제 유형을 입력해 주세요",
      "cost is required": "한국 내 체류기간 동안 비용을 입력해 주세요",
      "payerName is required": "성함/회사 (또는 단체) 명칭을 입력해 주세요",
      "costPayer is required": "请选择谁将承担在韩期间的费用",
      "payerRelationship is required": "비용결제자와 신청인의 관계를 입력해 주세요",
      "haveHelper is required": "请选择是否有协助人",
      "helperName is required": "서류작성도움자 이름을 입력해 주세요",
      "helperBirthDate is required": "서류작성도움자의 생년월일을 입력해 주세요",
      "helperContact is required": "서류작성도움자의 전화번호를 입력해 주세요",
      "helperRelationship is required": "신청인과의 관계를 입력해 주세요",
      "Please enter the phone number": "전화번호를 입력해 주세요",
    },
    save2nextBtn: "保存，并下一步"
  },
  /*---------------------------   申请人资料     --------------------------*/
  /*上传护照首页*/
  visaForm1: {
    title: "护照首页模板",
    container: {
      s1: "1、护照离出发日必须有6个月以上有效期",
      s2: "2、拍摄上传彩色的护照首页，字体清晰可见"
    },
    button: "点击开始拍照"
  },
  "visaForm1-1": {
    container: {
      s1: "以下内容为自动识别内容，请仔细检查，如有问题可直接修改",
    },
    form: {
      passportNum: {
        name: "护照号码",
        placeholder: "",
      },
      surnameZh: {
        name: "姓（中文）",
        placeholder: ""
      },
      nameZh: {
        name: "名（中文）",
        placeholder: ""
      },
      surnameEn: {
        name: "姓（英文）",
        placeholder: ""
      },
      nameEn: {
        name: "名（英文）",
        placeholder: ""
      },
      gender: {
        name: "性别",
        male: '男',
        female: '女'
      },
      birthDate: {
        name: "出生日期",
        placeholder: ""
      },
      birthPlaceZh: {
        name: "出生地点（中文）",
        placeholder: ""
      },
      birthPlaceEn: {
        name: "出生地点（英文）",
        placeholder: ""
      },
      issuancePlaceZh: {
        name: "签发地点（中文）",
        placeholder: ""
      },
      issuancePlaceEn: {
        name: "签发地点（英文）",
        placeholder: ""
      },
      issuanceDate: {
        name: "签发日期",
        placeholder: ""
      },
      issuancePeriod: {
        name: "有效期至",
        placeholder: ""
      },
    },
    "rulesErr": {
      'passportNum is required': "请填写护照号码",
      "surnameZh is required": "请填写姓（中文）",
      "surnameEn is required": "请填写姓（英文）",
      "nameZh is required": "请填写名（中文）",
      "nameEn is required": "请填写姓（英文）",
      "birthPlaceZh is required": "出生地点（中文）",
      "birthPlaceEn is required": "出生地点（英文）",
      "issuancePlaceZh is required": "请填写签发地点（中文）",
      "issuancePlaceEn is required": "请填写签发地点（英文）",
    },
    reUploadBtn: "重新上传",
    save2next: "保存，并下一步"
  },
  /*上传身份证*/
  "visaForm2": {
    IDCard: {
      s1: "身份证人像面",
      s2: "身份证国徽面",
      s3: "点击开始拍照",
      instructions: {
        s1: "1、清晰拍摄正反面、不能反光",
        s2: "2、请注意露出四个边角，不要压边拍摄",
        s3: "3、临时身份证不可申请签证",
      }
    },
    minor: {
      title: "未成年儿童，未办理身份证",
      instructions: "提醒 ：未成年儿童，未办理身份证时，邮寄材料里需要提供出生医学证明复印件，并上传原件照片。"
    },
    saveBtn: "保存，并下一步"
  },
  /*上传电子照片*/
  "visaForm3": {
    title: "上传电子照片",
    instructions: {
      s1: "1、近6个月内拍摄的2寸(3.5cmx4.5cm)白底彩照;",
      s2: "2. 邮寄申请资料里必须和电子照片一致。",
      s3: "3、不得佩戴眼镜、夸张首饰，不得穿着制服;双眼直视照相机;露出双耳;",
      s4: "嘴巴闭合;头发不能遮住两眼;左右肩膀保持平衡;",
      s5: "4、不能因容貌变化、相片变色、褪色等原因,与目前容貌发生明显差异。",
      s6: "*我们提供照片自助拍摄和打印服务,请在下单时选择",
    },
    takePhotoBtn: "点击开始拍照",
    uploadPhotoBtn: "我已有签证照，直接上传"
  },
  "visaForm3-1": {
    title: "上传电子照片",
    uploadSu: "电子照片已上传",
    instructions: {
      s1: "1、近6个月内拍摄的2寸(3.5cmx4.5cm)白底彩照;",
      s2: "2. 邮寄申请资料里必须和电子照片一致。",
      s3: "3、不得佩戴眼镜、夸张首饰，不得穿着制服;双眼直视照相机;露出双耳;",
      s4: "嘴巴闭合;头发不能遮住两眼;左右肩膀保持平衡;",
      s5: "4、不能因容貌变化、相片变色、褪色等原因,与目前容貌发生明显差异。",
      s6: "*我们提供照片自助拍摄和打印服务,请在下单时选择",
    },
    reUploadBtn: "重新上传",
    save2nextBtn: "保存，并下一步"
  },
  /*个人信息*/
  "visaForm4": {
    "question1": "*是否曾用别名入境韩国或从韩国出境？",
    "surnameZh": "姓（中文）",
    "nameZh": "名（中文）",
    "question2": "*是否拥有双重国籍？",
    "orderNationality": "*其它国家国籍",
    "orderNationalityPlaceholder": "请输入国家名称",
    "question3": "*是否持有其它护照？",
    "question4": "*其它护照类型",
    "passportType": {
      "type1": "外交护照",
      "type2": "公务护照",
      "type3": "普通护照",
      "type4": "其它"
    },
    "passportNum": {
      name: "*护照号码",
      placeholder: "请输入护照号码"
    },
    "issuancePlace": {
      name: "*签发地点",
      placeholder: "请输入签发地点"
    },
    issuancePeriod: {
      name: "*有效期至",
      placeholder: "请输入有效期"
    },
    "issuanceOrg": {
      name: "*签发机关",
      placeholder: "请输入签发机关"
    },
    rulesErr: {
      "surnameZh is required": "请填写姓（中文）",
      "nameZh is required": "请填写名（中文）",
      "orderNationality is required": "请输入国家名称",
      "passportNum is required": "请输入护照号码",
      "issuancePlace is required": "请输入签发地点",
      "issuancePeriod is required": "请输入有效期",
      "issuanceOrg is required": "请输入签发机关",
    },
    "yes": "是",
    "no": "否",
    "save2nextBtn": "保存，并下一步"
  },
  /*联系人信息*/
  "visaForm5": {
    description: "填写申请表时，请填写真实有效信息，否则将导致拒签",
    address: "*本国住址",
    addressPlaceholder: "请输入本国地址",
    nowAddress: "*现居住地址",
    nowAddressPlaceholder: "请输入现居住地址",
    mobile: "*手机",
    mobilePlaceholder: "请输入手机号码",
    telephone: "*电话",
    telephonePlaceholder: "请输入电话号码",
    email: "*邮箱",
    emailPlaceholder: "请输入邮箱",
    emergencyContact: "*紧急联系人",
    contactName: "*姓名",
    contactNamePlaceholder: "请输入紧急联系人姓名",
    contactMobile: "*电话",
    contactMobilePlaceholder: "请输入紧急联系人电话",
    contactNation: "*居住国家",
    contactRelation: "*与申请人关系",
    save2nextBtn: "保存，并下一步",
    rulesErr: {
      "address is required": "请输入本国地址",
      "nowAddress is required": "请输入现居住地址",
      "mobile is required": "请输入手机号码",
      "telephone is required": "请输入电话号码",
      "email is required": "请输入邮箱",
      "contactName is required": "请输入紧急联系人姓名",
      "contactMobile is required": "请输入紧急联系人电话",
      "contactNationValue is required": "请选择居住国家",
      "contactRelationValue is required": "请选择与联系人关系",
    }
  },
  /*家庭成员信息*/
  "visaForm6": {
    maritalStatus: {
      title: "*婚姻状况",
      status1: "已婚",
      status2: "未婚",
      status3: "单身",
    },
    spouseInfo: {
      title: "*配偶信息",
      surnameZh: "姓（中文）",
      surnameZhPlaceholder: "请输入配偶姓",
      nameZh: "名（中文）",
      nameZhPlaceholder: "请输入配偶名",
      birthDate: "*出生日期",
      birthDatePlaceholder: "请选择出生日期",
      nationality: "*国籍",
      mobile: "*电话",
      mobilePlaceholder: "请输入配偶电话",
      address: "*居住地址",
      addressPlaceholder: "请输入居住地址"
    },
    rulesErr: {
      "surnameZh is required": "请输入配偶姓",
      "nameZh is required": "请输入配偶名",
      "birthDate is required": "请选择出生日期",
      "contactNationValue is required": "请选择国籍",
      "mobile is required": "请输入配偶电话",
      "address is required": "请输入居住地址",
    },
    save2nextBtn: "保存，并下一步"
  },
  /*教育信息*/
  "visaForm7": {
    educationBg: {
      title: "*最高学历",
      value1: "硕士/博士",
      value2: "学士",
      value3: "高中",
      value4: "其它",
    },
    otherEducationBg: "*其它学历，请说明",
    schoolName: "*学校名称",
    schoolLocation: "*学校所在地",
    profession: {
      title: "*当前职业",
      value1: "事业家",
      value2: "自雇",
      value3: "公司职员",
      value4: "公务员",
      value5: "学生",
      value6: "无业",
      value7: "退休",
      value8: "其它",
    },
    rulesErr: {
      "otherEducationBg is required": "请输入其他学历说明",
      "schoolName is required": "请输入学校名称",
      "schoolLocation is required": "请输入学校所在地",
      "occupationDescription is required": "请输入其他职业说明",
    },
    occupationDescription: "其他职业说明",
    otherProfession: "*其它职业，请说明",
    save2nextBtn: "保存，并下一步"
  },
  /*访问信息*/
  "visaForm8": {
    access: {
      date: "*拟入境日期",
      datePlaceholder: "拟入境日期",
      days: "*拟滞留天数",
      mobile: "*在韩联系电话",
      address: "*在韩滞留地址/酒店"
    },
    families: {
      question: "*是否有同行家属？",
      yes: "是",
      no: "否",
      family: {
        title: "*同行家属",
        name: "*姓名",
        birthDate: "*出生日期",
        nationality: "*国籍",
        contactRelation: "*与申请人关系"
      }
    },
    records: {
      question1: "*近五年内是否访问过韩国？",
      count: "*五年内访韩次数",
      purpose: "*近期入境目的",
      question2: "*近五年内是否访问过除韩国外其它国家？",
      countries: {
        title: "其它访问国家",
        name: "*国家名称",
        purpose: "*访问目的",
        period: "有效期"
      },
      dateStartPlaceholder: "开始时间",
      dateEndPlaceholder: "截止时间",
      yes: "是",
      no: "否",
    },
    rulesErr: {
      "date is required": "请选择拟入境日期",
      "days is required": "请填写拟滞留天数",
      "mobile is required": "请填写在韩联系电话",
      "address is required": "请填写在韩滞留地址",
      "name is required": "请填写同行家属姓名",
      "birthDate is required": "请选择同行家属生日",
      "country is required": "请选择同行家属国籍",
      "relationship is required": "请选择与同行家属关系",
      "visitedValue is required": "请选择近期访问次数",
      "visitedPurposeValue is required": "请选择近期访问目的",
      "countryName is required": "请选择国家",
      "visitedPurpose is required": "请选择访问目的",
      "dateStart is required": "请选择开始日期",
      "dateEnd is required": "请选择截止日期",
    },
    save2nextBtn: "保存，并下一步"
  },
  /*其他信息*/
  visaForm9: {
    invitation: {
      question: "*是否在韩国有邀请人或邀请单位？",
      yes: "是",
      no: "否",
      name: "*邀请人姓名或邀请单位名",
      info: "*邀请人出生日期或邀请单位登记证号码",
      contactRelation: "*与申请人关系",
      invitedAddress: "*邀请人或邀请单位地址",
      mobile: "*联系电话"
    },
    cost: {
      question: "*谁将承担在韩国期间的费用",
      value1: "自己",
      value2: "邀请方",
      value3: "他人支付",
      paymentType: "*支付类型",
      cost: "*在韩期间费用（以美元为准）",
      payerName: "*姓名/单位（或团队）名称",
      payerRelationship: "*费用承担者与申请人关系"
    },
    assist: {
      question: "*是否有人协助填写本申请",
      yes: "是",
      no: "否",
      name: "*姓名",
      birthDate: "*出生日期",
      mobile: "*电话",
      contactRelation: "*与申请人关系",
      birthDatePlaceholder: "出生日期"
    },
    rulesErr: {
      "invitedName is required": "请填写邀请人姓名或邀请单位名",
      "invitedInfo is required": "请填写邀请人出生日期或邀请单位登记证号码",
      "invitedAddress is required": "请填写邀请人或邀请单位地址",
      "invitedContact is required": "请填写邀请人联系电话",
      "payType is required": "请填写支付类型",
      "cost is required": "请填写在韩期间费用",
      "payerName is required": "请填写姓名/单位（或团队）名称",
      "payerRelationship is required": "请选择费用承担者与申请人关系",
      "helperName is required": "请填写协助人姓名",
      "helperBirthDate is required": "请选择协助人的出生日期",
      "helperContact is required": "请填写协助人的联系方式",
      "helperRelationship is required": "请选择与协助人的关系",
    },
    save2nextBtn: "保存，并下一步"
  },
  /*其他材料*/
  visaForm10: {
    business: {
      title: "请上传公司营业执照",
      toDetail: "查看样图",
      uploadBtn: "点击上传",
      selectBtn: "从最近上传记录里选择",
      instructions: {
        s1: "说明：",
        s2: "1. 营业执照务必清晰",
        s3: "2. 必须加盖公司公章",
        s4: "3. 仅支持png/jpg格式图片",
        s5: "4. 图片大小不得超过500kb",
      }
    },
    invitation: {
      title: "请上传韩方邀请函图片（含邀请事由和归国保证书等内容）",
      toDetail: "查看样图",
      uploadBtn: "点击上传",
      selectBtn: "从最近上传记录里选择",
      instructions: {
        s1: "说明：",
        s2: "1. 邀请公函务必清晰",
        s3: "2. 必须加盖公司公章",
        s4: "3. 仅支持png/jpg格式图片",
        s5: "4. 图片大小不得超过500kb",
      }
    },
    registered: {
      title: "",
      toDetail: "查看样图",
      uploadBtn: "点击上传",
      selectBtn: "从最近上传记录里选择",
      instructions: {
        s1: "",
        s2: "",
        s3: "",
        s4: "",
        s5: "",
      }
    },
    verification: {
      title: "",
      placeholder: "",
    },
    lawDesc: "",
    save2nextBtn: "保存，并下一步"
  },
  /*寄送方式*/
  sendWay: {
    "Confirm delivery and payment information": "택배 및 결제 정보 확인",
    "To apply for together": "신청 같이 하기",

    "outgoing courier information": "보내는 택배 정보",
    desc: "서류 보내는 방식을 선택해 주세요. 만약 신청하지 않은 신청인이 있다면 삭제 해 주세요",
    "Use express delivery": "택배로 서류 제출",
    "To visit the center": "센터를 방문하여 서류 제출",
    "Sender name": "*보내는 사람 이름",
    "Mobile phone number": "*휴대폰 번호",
    "Select area": "*지역 선택",
    "Detailed address": "*상세한 주소",
    "Commonly used address": "상용주소록에서 선택하여 사용",

    "Appointment Information": "예약정보",
    "Number of general visa applications": "일반 비자 신청 수",
    "Number of urgent visa applications": "급행 비자 신청 수",
    "Name of sender": "비자신청서류 제출자 성함",
    "phone number": "전화번호",
    "Relationship with applicant": "신청인과의 관계",
    "Estimated time of visit": "방문 예정시간",
    "exit date": "출국 날짜",
    "Select Date": "날짜 선택",
    "Please select a date to make a reservation visit": "예약방문할 날짜를 선택해 주세요",
    "Please select a time to make a reservation visit": "예약방문할 시간을 선택해 주세요",
    "Appointment reminders": "예약 도움말",
    "Please enter the sender name": "비자신청서류 제출자 성함을 입력해 주세요",
    "Please enter your mobile phone number": "휴대폰 번호를 입력해 주세요",
    "Please select a estimated time of visit": "방문 예정시간을 선택해 주세요",
    "Please select a date to go abroad": "출국 날짜를 선태해 주세요",
    "Check and go to next page": "확인 및 다음으로 이동",
    state: {
      Myself: "본인",
      "Family members": "가족"
    },

    way: {
      type1: "使用快递寄送材料",
      type2: "自己送材料到签证中心"
    },
    sendList: {
      name: "*发件人姓名",
      phone: "*手机号",
      area: "*选择地区",
      provinceId: "请选择省",
      cityId: "请选择市",
      districtId: "请选择区",
      address: "详细地址",
      addAddress: "自动添加到常用地址",
      selectAddress: "选择常用地址"
    },
    reserveTime: {
      selectDate1: "选择预约材料日期",
      selectDate2: "选择预约材料时间",
      reserveTimePlaceholder: "请选择预约日期",
    },
    notice: {
      title: "预约须知",
      s1: "※ 网上预约者请务必准备好申请资料，可大大减少您申请签证的等待时间，继而提高资料接收效率。",
      s2: "网上预约可预约2个工作日之后的日期（工作日基准）",
      s3: "例：今天是12月1日，可申请预约12月3日及以后的日期；",
      s4: " ①  网上预约开放时间为当月及后续两个月，",
      s5: "例：2016年1月时，系统开放可预约时间至3月，如此类推；",
      s6: "②  预约成功前来签证中心申请时，请携带预约确认单；",
      s7: "③  同一个户口本的直系亲属（2寸以内）可由网上预约申请者代理申请签证；",
      s8: "④  同一个预约号码的其他申请者（非直系亲属）一定要本人及网上预约申请者一起到签证申请中心方可办理签证；",
      s9: "⑤  网上预约者不可重复申请预约，重复的预约将会被取消；",
      s10: "* 签证申请时，若因资料不足或不符，签证中心可不予以接收，因此申请人请务必事先准备好所需资料",
    },
    btn: {
      btn1: "查看所需资料内容",
      btn2: "所需资料发送到邮箱"
    },
    rulesErr: {
      "name is required": "보내는 사람의 이름을 입력해주세요",
      "phone is required": "보내는 사람 휴대폰 번호를 입력해 주세요",
      "address is required": "보내는 사람의 상세한 주소를 입력해 주세요",
      "sendType is required": "请选择寄送方式",
      "provinceId is required": "请选择省份",
      "cityId is required": "请选择城市",
      "districtId is required": "请选择市区",
      "sendListReserveTime is required": "请选择自送预约日期",
    }

  },
  receiveWay: {
    "working hours": "근무 시간", "address": "주소", "phone number": "전화번호", "e-mail": "이메일",
    "Confirm delivery and payment information": "택배 및 결제 정보 확인",
    "Return Delivery Information": "여권수령 택배 정보",
    "Choose express": "여권수령 택배 선택",
    "Visit the center to receive documents": "센터에 방문하여 여권 수령",
    "returning address": "여권수령 택배주소",
    "The recipient": "*받는 사람",
    "Mobile phone number": "*휴대폰번호",
    "Please select district": "*지역선택",
    "Detailed address": "*상세한 주소",
    "Commonly used address": "상용주소록에서 사용",
    "Add Return Address": "여권수령 주소 추가",
    "Please select an application to return to your address now": "상기 주소로 여권수령 할 신청자를 선택해 주세요",
    "Confirm the payment": "확인하고 결제하기",
    "Are you sure of payment": "결제확인",
    way: {
      title: "请选择取件方式",
      type1: "使用快递回寄地址",
      type2: "签证中心自取件"
    },
    receiveAddress: {
      title: "回寄地址",
      btn1: "编辑地址",
      btn2: "使用常用地址"
    },
    selectApply: {
      title: "请选择申请人",
      desc: "出签后下列申请人的资料会一同寄回当前地址"
    },
    addAddressBtn: "增加签证回寄地址",
    rulesErr: {
      "name is required": "请填写收件人姓名",
      "phone is required": "请填写收件人联系方式",
      "province is required": "请选择省份",
      "city is required": "请选择城市",
      "district is required": "请选择县区",
      "address is required": "请填写收件人详细地址",
    }
  },
  confirmPay: {
    "Confirm payment information": "결제 정보 확인",
    "Delivery charge": "택배 비용",
    "Delivery check": "택배 조회",
    "return express fee": "리턴 택배 비용",
    "Payment amount": "결제금액",
    "payment method": "결제방식 선택",
    "alipay": "알리페이",
    "WeChat pay": "위챗페이",
    "To check and pay": "확인 및 결제"
  },
  newAddress: {
    name: {
      title: "联系人",
      placeholder: "请输入联系人姓名"
    },
    phone: {
      title: "手机号码",
      placeholder: "请输入手机号码"
    },
    address: {
      title: "选择地址",
      placeholder: "请选择地址"
    },
    completeAddress: {
      title: "详细地址",
      placeholder: "请输入详细地址"
    },
    rulesErr: {
      "name is required": "请填写联系人姓名",
      "phone is required": "请填写联系人手机号",
      "provinceid is required": "请选择省份",
      "cityId is required": "请选择城市",
      "districtid is required": "请选择市区",
      "completeAddress is required": "请填写详细地址",
    },
    confirmBtn: "确定"
  },
  saveBasicInfo: {
    "Visa application information": "비자 신청 정보",
    "Upload basic information": "기본 자료 업로드",
    "Submit application information": "신청 정보 제출",
    "View and save application information": "신청 정보 확인 및 저장",
    "Upload passport": "여권사진 업로드",
    "attention": "주의:  여권사진이 선명하지 않을 경우 식별이 어려우니 각별히 조심해서 체크해 주세요.",
  },
  saveApplyInfo: {
    "Visa application information": "비자 신청 정보",
    "Upload basic information": "기본 자료 업로드",
    "Submit application information": "신청 정보 제출",
    "View and save application information": "신청 정보 확인 및 저장",
    "Check and go to the next page": "확인후 다음페이지로",

    "Please check if the personal information is correct": "개인 정보가 정확한지 확인해 주세요",
    "Please check if the Contact information is correct": "연락처 정보가 정확한지 확인 해 주세요",
    "Please check if the marital status and family member information is correct": "혼인 및 가족 정보가 정확한지 확인 해 주세요",
    "Please check if the educational information is correct": "교육 정보가 정확한지 확인 해 주세요",
    "Please check if the job information is correct": "직업 정보가 정확한지 확인 해 주세요",
    "Please check if the visit information is correct": "방문 정보가 정확한지 확인 해 주세요",
    "Please check if the invitation information is correct": "초청 정보가 정확한지 확인 해 주세요",
    "Please check if the expense information is correct": "비용 정보 비용 정보가 정확한지 확인 해 주세요",
    "Save success": "저장 성공",
  },
  confirmApply: {
    /*签证信息*/
    "Visa application information": "비자 비자 신청 정보",
    "Upload basic information": "기본 자료 업로드",
    "Submit application information": "신청 정보 제출",
    "View and save application information": "신청 정보 확인 및 저장",
    "attention": " 주의:아래 정보를 자세히 확인하십시오. 제출 후에는 수정이 불가합니다. ",
    "Application information": "신청정보",
    "the place where you live and work": "상주생활근무지",
    "Your application will be submitted to": "고객님의 신청을 제출 할 영사관은",
    "Visa type": "비자유형",
    "Visa entries": "비자 횟수",
    "The urgent": "급행",
    "Modify": "수정",

    "Please check the exact data": "자료가 진실하고 정확하다는 것을 확인 하세요",
    "Please enter the applicant name": "신청인의 성함을 입력해 주세요",
    "Confirm that the name is used for the signature of the application form": "이 성함을 신청서 서명 내용으로 사용하시겠습니까?",

    /*护照信息*/
    passport: {
      "Passport information": "여권 정보",
      "Modify": "수정",
      "Passport number": "여권 번호",
      "The surname（Chinese）": "성 (중국어)",
      "Name（Chinese）": "이름(중국어)",
      "Family Name（English）": "성(영문)",
      "Given Name（English）": "이름(영문)",
      "gender": "성별",
      "Date of birth": "생년월일",
      "Place of birth": "출생지",
      "Country of birth": "출생 국가",
      "Date of Issue": "발급일",
      "place of issue": "발급지",
      "Validity Period": "유효기간",
    },

    /*身份证信息*/
    idCard: {
      "ID information": "신분증 정보",
      "Modify": "수정",
      "Name": "성함",
      "gender": "성별",
      "ethnic groups": "민족",
      "Date of birth": "생년월일",
      "address": "주소",
      "Id card number": "신분증 번호",
      "issuing authority": "발급 기관",
      "Validity Period": "유효기간",
    },
    /*个人信息*/
    personal: {
      "personal information": "개인 정보",
      "Modify": "수정",
      "Have you entered or left Korea under any other name?": "기타 성함으로 입국했거나 한국에서 출국한 적이 있습니까?",
      "YES": "네",
      "NO": "아니요",
      "Other Name (the surname)": "기타 성함 (성)",
      "Other Name(name)": "기타 성함(이름)",
      "Whether you have dual nationality": "이중국적을 갖고 있습니까?",
      "Nationality of other countries": "다른 나라 국적",
      "Do you have other passports?": "다른 여권을 소지하고 계십니까?",
      "Other passport types": "기타 여권 종류",
      "Passport number": "여권번호",
      "issuing country": "발급국가",
      "Validity Period": "유효 기간",
    },
    /*联系信息*/
    contact: {
      "Contact Information": "연락 정보",
      "Modify": "수정",
      "Home address": "본국 내 주소",
      "Current residential address": "현 거주지",
      "Mobile phone number": "휴대폰번호",
      "phone number": "전화번호",
      "e-mail": "이메일",
      "Emergency contact information": "긴급 연락처 정보",
      "Name": "이름",
      "Country of residence": "거주국가",
      "Relationship with the applicant": "신청인과의 관계",
    },
    /*家庭成员*/
    member: {
      "Marital status and family member information": "가족 정보",
      "Modify": "수정",
      "Marital status": "혼인여부",
      "spouse information": "배우자 정보",
      "Family Name": "성",
      "Given Name": "이름",
      "Date of birth": "생년월일",
      "Nationality": "국적",
      "residential address": "거주 주소",
      "phone number": "전화번호",
      "Have children or not": "자녀 유무",
      "NO": "아니요",
      "YES": "네",
      "the number of children": "자녀 수",
      state: {
        "married": "기혼",
        "divorce": "이혼",
        "single": "미혼",
      }
    },
    /*教育信息*/
    educational: {
      "educational information": "교육 정보",
      "Modify": "수정",
      "the highest academic qualifications": "최고 학력",
      "School name": "학교 명칭",
      "School location": "학교 소재지",
      "Other qualifications please specify": "기타 학력 설명해주세요",
      state: {
        "Master": "석사/박사",
        "Bachelor": "학사",
        "High school": "고등학교",
        "other": "기타",
      }
    },
    /*职业信息*/
    professional: {
      "Professional information": "직업 정보",
      "The current career": "현재 직업",
      "Name of company/agency/school": "회사/기관/학교 명칭",
      "Occupation/course": "직업/커리큘럼",
      "Company/office/school address": "회사/기관/학교 주소",
      "Company/office/school contact number": "회사/기관/학교 연결 전화",
      "Other job description": "기타 직업 설명",
      state: {
        "entrepreneurs": "기업가",
        "self-employment": "자영업",
        "Company employees": "회사원",
        "Civil servants": "공무원",
        "students": "학생",
        "unemployed": "무직",
        "retired": "퇴직",
        "other": "기타",
      }
    },
    /*访问信息*/
    access: {
      "access information": "방문 정보",
      "days of detention": "체류일수",
      "Intended date of entry": "입국 예정 날짜",
      "Date of departure": "출국 날짜",
      "Contact number in Korea": "한국에서의 전화번호",
      "Address/hotel in Korea": "한국 내 체류하는 주소/호텔",
      "Application for entry": "입국 신청 사유",
      "Are there any family members with you?": "동행가족분이 있습니까?",
      "NO": "아니요",
      "YES": "네",
      "name(pinyin)": "성함(병음)",
      "Date of birth": "생년월일",
      "nationality": "국적",
      "Relationship with applicant": "신청인과의 관계",
      "Are there any family members living in Korea?": "한국에 거주하는 가족이 있습니까?",
      relationshipState: {
        "spouse": "배우자", "children": "자녀", "parents": "부모", "Brothers and sisters": "형제 자매",
      },
      Application: {
        title: "*입국 신청 사유",
        value1: "여행/경유 여행/경유",
        value2: "회의 등 행사 참가",
        value3: "의료 관광",
        value4: "단기 비즈니스",
        value5: "학습/트레이닝",
        value6: "취업 활동",
        value7: "무역/투자/주재원",
        value8: "친척 방문/친구 방문",
        value9: "결혼/이민",
        value10: "외교/공무",
        value11: "기타",
        other: "기타 입국 사유",
        otherPlaceholder: "기타 입국 사유를 입력해 주세요"
      },
      "Have you visited the rok in the past five years?": "최근 5년 동안 한국 외 다른 나라를 방문한 적이 있습니까? ",
      "Recent Entry Purpose": "최근 입국 목적",
      "Visit purpose": "방문 목적",
      "During the visit": "방문 기간",
      "Have you visited any other countries other than Korea in the last five years?": "최근 5년 동안 한국 외 다른 나라를 방문한 적이 있습니까?",
      "Country name": "국가 명칭",
    },
    /*邀请方信息*/
    invitation: {
      "Invitation information": "초청 관련 정보",
      "Modify": "수정",
      "Is there an invitation or an invitation unit in Korea?": "한국에 초청인이나 초청업체가 있습니까?",
      "NO": "아니요",
      "YES": "네",
      "Invitee name or invite unit name": "초청인 성명 또는 초청업체 명칭",
      "Date of invitation or registration number of invitee for flat-enterprise registration": "초청인 출생 날짜 또는 초청업체 사업자 등록증 번호",
      "Relationship with applicant": "신청인과의 관계",
      "Address of inviter or unit": "초청인 또는 초청업체 주소",
      "phone number": "전화번호",
    },
    /*费用信息*/
    cost: {
      "expense information": "비용 정보",
      "Modify": "수정",
      "Expenses during the period in Korea (based on US dollars)": "한국에 체류기간 비용(달러 기준)",
      "Payment type": "결제 유형",
      "Name/unit (or team) name": "이름/회사 (또는 단체) 명칭",
      "The relationship between the undertaker and the applicant": "결제자와 신청인의 관계",
      "phone number": "전화번호",
    },
    /*协助*/
    Helper: {
      "Helper information": "서류작성도움자 정보",
      "Modify": "수정",
      "Is there anyone who helped me fill out this application?": "본 신청서 작성에 도와준 분이 있습니까?",
      "name": "성함",
      "Date of birth": "생년월일",
      "phone number": "전화번호",
      "Relationship with applicant": "신청인과의 관계",
    },
    "Required materials": "필요서류",
    "Click to view the required materials": "필요한 자료 클릭 해 보기",
    "Send required information to mailbox": "필요한 자료를 이메일로 전송 받기",
    confirmed: "본인은 표에 기재된 내용을 사실적이고 정확하게 확인하였으며 (대한민국출입국관리법) 관련 규정을 준수할 것을 성명 및 보증합니다",
    confirmBtn: "정보 확인",
    "View the application": "신청서 보기",
    "Please sign the QR code on your phone": "휴대폰으로 QR코드를 스캔하시고 싸인 해 주세요",
    "Please sign the QR code with WeChat": "위챗으로 QR코드를 스캔 하시고 싸인 해 주세요",
    cancelBtn: "취소",
    signed: "싸인 완료"
  },
  /*---------------------------   公共     --------------------------*/
  "common": {
    /*toast*/
    "toastLoading": "正在加载...",
    "toastWait": "请稍后...",
    /*loading*/
    "loading": "加载中...",
    "finished": "没有更多数据了",
    "loadErr": "加载失败,点击重试",
    /*select*/
    "pleaseSelect": "请选择"
  }
}




// WEBPACK FOOTER //
// ./src/assets/languages/ko.js